import { Component, OnInit } from '@angular/core';
import { ApiInit } from 'src/app/utils/api-init';
import { NotificationService } from '../../services/notification.service';
import { Notification } from 'src/app/interfaces/notification';
import { SettingsService } from 'src/app/services/settings.service';
import { HttpParams } from '@angular/common/http';
import { DeepLinkService } from 'src/app/services/deep-link.service';
import { CurrentWhiteLabelApplication } from 'src/app/utils/current-white-label-application';
import { TranslateModule } from '@ngx-translate/core';
import { TimeAgoPipe } from '../../pipes/time-ago.pipe';
import { LoaderComponent } from '../../components/loader/loader.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ImgFallBackDirective } from '../../directives/img-fallback.directive';
import { NgIf, NgFor } from '@angular/common';
import {
  IonContent,
  IonBackButton,
  IonRefresher,
  IonRefresherContent,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
} from '@ionic/angular/standalone';
import { DivClickDirective } from 'src/app/directives/div-click.directive';
import { StateNoticeComponent } from '../../components/state-notice/state-notice.component';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    ImgFallBackDirective,
    InlineSVGModule,
    LoaderComponent,
    TimeAgoPipe,
    TranslateModule,
    IonContent,
    IonBackButton,
    DivClickDirective,
    IonRefresher,
    IonRefresherContent,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    StateNoticeComponent,
  ],
})
export class NotificationsPage implements OnInit {
  notifications: any[] = [];
  page: number = 1;
  perPage: number = 20;
  totalItems: number;
  notificationsLoaded: boolean = false;
  whitelabelIcon: string;
  whitelabelName: string;

  constructor(
    private apiInit: ApiInit,
    private settingsService: SettingsService,
    private notificationService: NotificationService,
    private deeplinkService: DeepLinkService,
    private app: CurrentWhiteLabelApplication
  ) {}

  ngOnInit() {
    this.whitelabelIcon = this.app.getIconThumbnails().small;
    this.whitelabelName = this.app.getName();
    this.apiInit.watch(() => {
      this.loadNotifications();
    });
  }

  async loadNotifications(event = null) {
    this.notificationsLoaded = false;
    try {
      const response = await this.notificationService.getNotifications(
        this.setUrlParams()
      );
      if (!this.notifications?.length || this.page == 1) {
        this.notifications = response.member;
      } else {
        this.notifications = this.notifications.concat(response.member);
      }
      this.totalItems = response.totalItems;
      this.page++;
    } catch {
    } finally {
      this.notificationsLoaded = true;
      if (event) event.target.complete();
    }
  }

  setUrlParams() {
    return new HttpParams()
      .set('page', this.page.toString())
      .set('perPage', this.perPage.toString());
  }

  handleRefresh(event) {
    this.page = 1;
    this.loadNotifications(event);
  }

  async openNotification(notification: Notification) {
    this.deeplinkService.checkLink(notification.link, null, false);
  }
}
